import { enableMapSet } from 'immer';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';

enableMapSet();
// After
const container = document.getElementById('app');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<App />);
